import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Scale, Eye, AlertTriangle } from 'lucide-react';
import ExpedientesNew from './ExpedientesNew';
import Actuaciones from './Actuaciones';
import ReclamacionExtrajudicial from './ReclamacionExtrajudicial';
import SupervisionExpedientes from './SupervisionExpedientes';
import EstafasBancarias from './EstafasBancarias';

const ExpedientesContainer = () => {
  const [activeTab, setActiveTab] = useState('expedientes');

  return (
    <div className="h-full">
      <Tabs value={activeTab} onValueChange={setActiveTab} className="h-full">
        <div className="border-b bg-white px-6">
          <TabsList className="h-12 bg-transparent border-b-0">
            <TabsTrigger 
              value="expedientes" 
              className="data-[state=active]:border-b-2 data-[state=active]:border-blue-600 rounded-none px-6"
            >
              Expedientes
            </TabsTrigger>
            <TabsTrigger 
              value="actuaciones"
              className="data-[state=active]:border-b-2 data-[state=active]:border-blue-600 rounded-none px-6"
            >
              Actuaciones
            </TabsTrigger>
            <TabsTrigger 
              value="supervision"
              className="data-[state=active]:border-b-2 data-[state=active]:border-blue-600 rounded-none px-6 flex items-center gap-2"
            >
              <Eye className="w-4 h-4" />
              Supervisión
            </TabsTrigger>
            <TabsTrigger 
              value="extrajudicial"
              className="data-[state=active]:border-b-2 data-[state=active]:border-blue-600 rounded-none px-6 flex items-center gap-2"
            >
              <Scale className="w-4 h-4" />
              Extrajudicial
            </TabsTrigger>
            <TabsTrigger 
              value="estafas-bancarias"
              className="data-[state=active]:border-b-2 data-[state=active]:border-blue-600 rounded-none px-6 flex items-center gap-2"
            >
              <AlertTriangle className="w-4 h-4" />
              Estafas Bancarias
            </TabsTrigger>
          </TabsList>
        </div>
        
        <TabsContent value="expedientes" className="m-0">
          <ExpedientesNew />
        </TabsContent>
        
        <TabsContent value="actuaciones" className="m-0">
          <Actuaciones />
        </TabsContent>
        
        <TabsContent value="supervision" className="m-0">
          <SupervisionExpedientes />
        </TabsContent>
        
        <TabsContent value="extrajudicial" className="m-0">
          <ReclamacionExtrajudicial />
        </TabsContent>
        
        <TabsContent value="estafas-bancarias" className="m-0">
          <EstafasBancarias />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ExpedientesContainer;
